import cn from "classnames";

// Mui
import { Box, Typography } from "@mui/material";

// Styles
import mainMenuStyles from "../../MainMenu.styles";

// Config
import { MenuItem } from "../../mainMenu.config";

// Icons
import CustomIcon from "components/CustomIcon";
import icons from "enums/icons";

const ItemLabel = ({
    item,
    handleNavigate,
    setSlide,
    isSubItem = false,
}: {
    item: MenuItem;
    handleNavigate: (item: MenuItem) => void;
    setSlide: (slide: number) => void;
    isSubItem?: boolean;
}) => {
    const classes = mainMenuStyles();

    const { startIcon, isSelected, label, endIcon, isExpanded, shouldExpand, goToSlide } = item;

    const handleItemClick = () => {
        if (goToSlide !== undefined) {
            setSlide(goToSlide);
            return;
        }
        handleNavigate(item);
    };

    return (
        <Box className={cn(classes.itemLabel)} onClick={handleItemClick}>
            {startIcon && (
                <Box className={classes.startIcon} mr={1}>
                    {startIcon}
                </Box>
            )}
            {isSubItem && (
                <Box className={classes.subItemIcon}>
                    {isSelected && <Box className={classes.subItemIconSelected} />}
                </Box>
            )}
            <Typography sx={{ fontSize: 16, letterSpacing: 0.5 }}>{label}</Typography>
            {endIcon && <Box className={classes.endIcon}>{endIcon}</Box>}
            {shouldExpand && (
                <Box className={classes.expandIcon}>
                    <CustomIcon icon={isExpanded ? icons.chevronUpThin : icons.chevronDownThin} />
                </Box>
            )}
        </Box>
    );
};

export default ItemLabel;
